import { useMemo } from 'react';
import { useApi } from '../../../providers/ApiProvider'
import WorkspaceSystem from './WorkspaceSystem';
import { useReduxTanStackSync } from '../../../providers/ReduxTanStackSyncProvider';

const useWorkspaceSystem = () => {
	const api = useApi();
	const sync = useReduxTanStackSync();

	return useMemo( () => new WorkspaceSystem( { api, sync } ), [ api, sync ] );
}

export default useWorkspaceSystem;
